import React, { useState } from 'react';
import DashboardLeftMenu from '../DashboardLeftMenu';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import { handleUserLog } from '../../Utils/Utils';

const ConfigureIntegration = () => {
    const [selectedChannel, setSelectedChannel] = useState('');
    const [key, setKey] = useState('');
    const [channelUrl, setChannelUrl] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedChannel || !channelUrl || !key) {
            alert('All fields are required.');
            handleUserLog("", "submit_button", "moengage_integration", "All fields are required.", "moengage_integration", "", { channel: selectedChannel });
            return;
        }

        // Simulate successful submission
        setSuccess(true);
        handleUserLog("", "submit_button", "moengage_integration", "Integration submitted successfully!", "moengage_integration", "", { channel: selectedChannel, channelUrl });

        // Optionally reset form fields
        setSelectedChannel('');
        setKey('');
        setChannelUrl('');

        // Hide success message after 3 seconds
        setTimeout(() => setSuccess(false), 3000);
    };

    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3><strong>Moengage Integration</strong></h3>
                            </div>
                        </div>

                        {success && (
                            <div className="alert alert-success" role="alert">
                                Integration submitted successfully!
                            </div>
                        )}

                        <div className="row">
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row align-items-center">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Enter URL <span className="text-danger">*</span></label>
                                                <input
                                                    type="url"
                                                    className="form-control"
                                                    value={channelUrl}
                                                    onChange={(e) => setChannelUrl(e.target.value)}
                                                    placeholder="Enter your URL"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Select Channel <span className="text-danger">*</span></label>
                                                <select
                                                    className="form-control"
                                                    value={selectedChannel}
                                                    onChange={(e) => setSelectedChannel(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Channel</option>
                                                    <option value="whatsapp">WhatsApp</option>
                                                    <option value="sms">SMS</option>
                                                    <option value="rcs">RCS</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Moengage Authkey <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={key}
                                                    onChange={(e) => setKey(e.target.value)}
                                                    placeholder="Enter your Moengage Authkey"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-4 text-end">
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <DashboardFooter />
            </div>
        </div>
    );
};

export default ConfigureIntegration;
